'use client';
import { usePooling } from '@/lib/hooks/usePooling';
import { useAppDispatch } from '@/lib/hooks/storeHook';
import { requestSolPrice } from '@/lib/services/price.service';
import { setSolanaPrice } from '@/lib/stores/dataSlice';

export default function PoolingClient() {
  const dispatch = useAppDispatch();
  // usePooling({
  //   poolingHandler: () => {
  //     getAndSetSolanaPrice();
  //   },
  //   interval: 20000,
  // });

  const getAndSetSolanaPrice = async () => {
    const solPrice = await requestSolPrice();
    dispatch(setSolanaPrice(solPrice ?? 220));
  };
  return <></>;
}
